// utils/countries.ts
import { countries, countriesIdsGlobalLottery } from '~/utils/constants/home.js'

/**
 * Returns the internal numeric ID for a country given its ISO 3166-1 alpha-2 code.
 * Returns `null` if the code is absent or unrecognised.
 * @param code - e.g. `'FR'`, `'PT'`
 */
export const getCountryIdByCode = (code?: string) => {
	if (!code) return null
	const c = countries.find((x) => x.code === String(code).toUpperCase())
	return c?.id ?? null
}

/**
 * Filters the global-lottery country list to only those whose ID appears in `idsCountries`.
 * @param idsCountries - Array of allowed country IDs.
 */
export const getCountriesGlobalLottery = (idsCountries: number[]) => {
	const filtered = countries.filter((x) => countriesIdsGlobalLottery.includes(x.id))
	return filtered.filter((x) => idsCountries.includes(x.id))
}

/**
 * Returns lotteries whose `country_id` matches `idCountry`.
 * Returns an empty array if the list is empty or `idCountry` is falsy.
 */
export const getLotteriesByCountry = (lotteries: any[], idCountry: number) => {
	if (lotteries.length === 0) return []
	if (!idCountry) return []
	return lotteries.filter((l) => l.country_id === idCountry)
}
